<div class="add-contract-modal" *transloco="let t; prefix: 'maintenanceCosting.modals.addContract'">
  <div class="add-contract-modal__header">
    <h3 class="add-contract-modal__title">{{ t('title') }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <div class="tab-indicator">
    <div class="tab-indicator__line" [class.active]="currentStep === 1"></div>
    <div class="tab-indicator__line" [class.active]="currentStep === 2"></div>
  </div>

  <form [formGroup]="contractForm" class="add-contract-modal__form">
    @if (currentStep === 1) {
      <div class="form-step">
        <div class="form-group">
          <label for="serviceCenterName" class="form-label">{{ t('fields.serviceCenterName') }} <span class="required">*</span></label>
          <input
            type="text"
            id="serviceCenterName"
            formControlName="serviceCenterName"
            class="form-control"
            [placeholder]="t('placeholders.serviceCenterName')">
        </div>

        <div class="form-group">
          <label class="form-label">{{ t('fields.asset') }} <span class="required">*</span></label>
          <app-account-asset-scope-selector
            [multiSelect]="true"
            [placeholder]="t('select.asset')"
            selectionMode="asset-only"
            [selectedScopes]="selectedAssets"
            (scopesChange)="onScopesChange($event)">
          </app-account-asset-scope-selector>
        </div>

        <div class="form-group">
          <label for="financialProviderName" class="form-label">{{ t('fields.financialProvider') }} <span class="required">*</span></label>
          <input
            type="text"
            id="financialProviderName"
            formControlName="financialProviderName"
            class="form-control"
            [placeholder]="t('placeholders.financialProvider')">
        </div>

        <div class="form-group">
          <label for="contractNumber" class="form-label">{{ t('fields.contractNumber') }} <span class="required">*</span></label>
          <input
            type="text"
            id="contractNumber"
            formControlName="contractNumber"
            class="form-control"
            [placeholder]="t('placeholders.contractNumber')">
        </div>

        <div class="form-group">
          <label class="form-label">{{ t('fields.contractType') }} <span class="required">*</span></label>
          <div ngbDropdown class="dropdown-wrapper" [autoClose]="true">
            <button type="button" class="form-control dropdown-toggle" ngbDropdownToggle>
              <div class="dropdown-inner">
                <span>{{ contractTypeLabel }}</span>
                <i class="ph ph-caret-down"></i>
              </div>
            </button>
            <div ngbDropdownMenu class="dropdown-menu">
              @for (type of contractTypes; track type.value) {
                <button type="button" class="dropdown-item" (click)="onContractTypeSelect(type)" ngbDropdownItem>
                  {{ t(type.labelKey) }}
                </button>
              }
            </div>
          </div>
        </div>

      </div>
    }

    @if (currentStep === 2) {
      <div class="form-step">

        <div class="form-row">
          <app-flatpickr-date-picker
            [label]="t('fields.startDate')"
            [required]="true"
            [value]="startDate"
            (valueChange)="onStartDateChange($event)"
            [disabled]="false"
            [allowPastDates]="true">
          </app-flatpickr-date-picker>

          <app-flatpickr-date-picker
            [label]="t('fields.endDate')"
            [required]="true"
            [value]="endDate"
            (valueChange)="onEndDateChange($event)"
            [disabled]="false"
            [allowPastDates]="true">
          </app-flatpickr-date-picker>
        </div>

        @if (isEndBeforeStart) {
          <span class="form-error">{{ t('endDateBeforeStart') }}</span>
        }

        <div class="form-group">
          <label for="contractPeriod" class="form-label">{{ t('fields.contractPeriod') }} <span class="required">*</span></label>
          <input
            type="number"
            id="contractPeriod"
            formControlName="contractPeriod"
            class="form-control"
            min="1"
            step="1"
            [placeholder]="t('placeholders.contractPeriod')">
          @if (!startDate) {
            <span class="form-hint">{{ t('startDateFirst') }}</span>
          }
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="variableCpk" class="form-label">{{ t('fields.variableCpk') }}</label>
            <input
              type="text"
              id="variableCpk"
              formControlName="variableCpk"
              class="form-control"
              placeholder="{{ currencySymbol }} 0.35">
          </div>

          <div class="form-group">
            <label for="contractMaxKm" class="form-label">{{ t('fields.contractMaximumKm') }}</label>
            <input
              type="text"
              id="contractMaxKm"
              formControlName="contractMaxKm"
              class="form-control"
              placeholder="985,000">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="fixedMonthlyCost" class="form-label">{{ t('fields.fixedMonthlyCost') }}</label>
            <input
              type="text"
              id="fixedMonthlyCost"
              formControlName="fixedMonthlyCost"
              class="form-control"
              placeholder="{{ currencySymbol }}772">
          </div>

          <div class="form-group">
            <label for="contractualKmMonth" class="form-label">{{ t('fields.contractualKmMonth') }}</label>
            <input
              type="text"
              id="contractualKmMonth"
              formControlName="contractualKmMonth"
              class="form-control"
              placeholder="13 500 {{ distanceSymbol }}">
          </div>
        </div>

        <div class="form-group">
          <label for="terms" class="form-label">{{ t('fields.terms') }}</label>
          <input
            type="text"
            id="terms"
            formControlName="terms"
            class="form-control"
            [placeholder]="t('placeholders.terms')">
        </div>
      </div>
    }
  </form>

  <div class="add-contract-modal__actions">
    @if (currentStep === 1) {
      <button type="button" class="btn-cancel" (click)="cancel()">
        <span>{{ 'common.cancel' | transloco }}</span>
      </button>
      <button type="button" class="btn-next" (click)="nextStep()" [disabled]="!isStep1Valid">
        <span>{{ 'common.next' | transloco }}</span>
      </button>
    }

    @if (currentStep === 2) {
      <button type="button" class="btn-cancel" (click)="previousStep()" [disabled]="isSaving">
        <span>{{ 'common.cancel' | transloco }}</span>
      </button>
      <button type="button" class="btn-save" (click)="save()" [disabled]="!canSave">
        @if (isSaving) {
          <span class="spinner-border spinner-border-sm"></span>
        } @else {
          <span>{{ t('submit') }}</span>
        }
      </button>
    }
  </div>
</div>